import LoginForm from "../../../layouts/auth/LoginForm";

export default function Login() {
  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded shadow mt-10">
      <h2 className="text-xl font-semibold mb-4">Đăng nhập</h2>
      <LoginForm />
    </div>
  );
}
